/* -------------------------------------------------------------------------- */
/*                          Componente DropdownInput                          */
/* -------------------------------------------------------------------------- */
// Este componente contiene un DropdownInput genérico que se utiliza en muchas pantallas de la aplicación.

import { Controller } from 'react-hook-form';
import { FormattedMessage } from 'react-intl';
import JobStatusDropdownInput from 'views/screens/Jobs/components/JobStatusDropdownInput';
import JobTypeDropdownInput from 'views/screens/Jobs/components/JobTypeDropdownInput';
import CategoriesDropdownInput from 'views/screens/vehicleMaintenance/components/CategoriesDropdownInput';
import NoticeTypeDropdownInput from 'views/screens/vehicleMaintenance/components/NoticeTypeDropdownInput';
import { appIntl } from '../../../utility/context/IntlGlobalProvider';
import JobPriorityDropdownInput from '../../screens/Jobs/components/JobPriorityDropdownInput';
import DropdownCategoriesIcons from '../../screens/vehicleMaintenance/components/dropDownIcons';
import CheckboxInput from '../CheckBoxInput';
import ColorPicker from '../ColorPicker';
import ContactsDropdown from '../ContactsDropdown';
import CustomersDropdown from '../CustomersDropdown';
import DateInput from '../DateInput';
import DriversDropdownInput from '../DriverDropDown';
import DropdownInput from '../DropdownInput';
import DurationInput from '../DurationInput';
import FormsDropdown from '../FormsDropdown';
import GeofencesDropdownInput from '../GeofenceDropDown';
import GeofenceShapeDropdownInput from '../GeofenceShapeDropdownInput';
import LocationClassesDropdownInput from '../LocationClassesDropdownInput';
import LocationsDropdownInput from '../LocationDropDown';
import Membership from '../Membership';
import MultiSelectInput from '../MultiSelectInput';
import NumericalInput from '../NumericalInput';
import RadioButtonsInput from '../RadioButtonInput';
import ScheduleDropdown from '../ScheduleDropdown';
import SwitchInput from '../SwitchInput';
import TextEditorInput from '../TextEditorInput';
import TextInput from '../TextInput';
import ThemeDropdown from '../ThemeDropdown';
import TimeInput from '../TimeInput';
import UnitsDropdown from '../UnitsDropdown';
import UsersDropdown from '../UsersDropdown';

interface Props {
  input: any;
  control: any;
  change?: any;
}

const validateText = (value) =>
  value && value.trim() ? undefined : appIntl().formatMessage({ id: 'common.requiredField' });

const validate = (value) =>
  value ? undefined : appIntl().formatMessage({ id: 'common.requiredField' });

const WebtrackCustomInput = (props: Props) => {
  //const [touched, setTouched] = useState(false);
  const { input, change, control } = props;

  return input.type === 'select' ? (
    <Controller
      control={control}
      shouldUnregister
      name={input.name}
      defaultValue={input.initialValue}
      rules={
        input.required && typeof input.customValidation === 'function'
          ? { required: input.required, validate: input.customValidation }
          : { required: input.required }
      }
      render={({ field, fieldState }) => (
        <DropdownInput
          field={field}
          fieldstate={fieldState}
          required={input.required}
          isClearable={input.isClearable}
          id={input.id}
          isInModal={true}
          options={input.options ? input.options : []}
          label={input.label}
          placeholder={input.placeholder}
          additionalonchangefunction={input.additionalonchangefunction}
          onInputChange={input.onInputChange}
          menuIsOpen={input.menuIsOpen}
          noOptionsMessage={input.noOptionsMessage}
          filterOption={input.filterOption}
        />
      )}
    />
  ) : input.type === 'multiSelect' ? (
    <Controller
      control={control}
      shouldUnregister
      name={input.name}
      defaultValue={input.initialValue}
      rules={
        input.required && typeof input.customValidation === 'function'
          ? { required: input.required, validate: input.customValidation }
          : { required: input.required }
      }
      render={({ field, fieldState }) => (
        <MultiSelectInput
          field={field}
          fieldstate={fieldState}
          required={input.required}
          isClearable={input.isClearable}
          id={input.id}
          isInModal={true}
          options={input.options ? input.options : []}
          label={input.label}
          placeholder={input.placeholder}
        />
      )}
    />
  ) : input.type == 'date' ? (
    <Controller
      control={control}
      shouldUnregister
      name={input.name}
      defaultValue={input.initialValue}
      rules={
        input.required && typeof input.customValidation === 'function'
          ? { required: input.required, validate: input.customValidation }
          : { required: input.required }
      }
      render={({ field, fieldState }) => (
        <DateInput
          field={field}
          fieldstate={fieldState}
          required={input.required}
          label={input.label}
          allowNulls={input.allowNulls}
          onChange={input.onchange || input.additionalonchangefunction || undefined}
          maxDate={input.maxDate}
          minDate={input.minDate}
          showTime={input.showTime}
          enableTime={input.enableTime}
        />
      )}
    />
  ) : input.type === 'text' ? (
    <Controller
      control={control}
      shouldUnregister
      name={input.name}
      defaultValue={input.initialValue}
      rules={
        input.required && typeof input.customValidation === 'function'
          ? { required: input.required, validate: input.customValidation }
          : { required: input.required }
      }
      render={({ field, fieldState }) => (
        <TextInput
          field={field}
          fieldstate={fieldState}
          required={input.required === true}
          id={input.id}
          label={input.label}
          appendcomponent={input.appendcomponent}
          type={input.textType ?? 'text'}
          placeholder={input.placeholder}
          forceinitialvalue={input.initialValue || input.forceinitialvalue}
          additionalonchangefunction={input.additionalonchangefunction}
          maxLength={input.maxLength}
        />
      )}
    />
  ) : input.type === 'textEditor' ? (
    <Controller
      control={control}
      shouldUnregister
      name={input.name}
      defaultValue={input.initialValue}
      rules={
        input.required && typeof input.customValidation === 'function'
          ? { required: input.required, validate: input.customValidation }
          : { required: input.required }
      }
      render={({ field, fieldState }) => (
        <TextEditorInput
          field={field}
          fieldstate={fieldState}
          required={input.required === true}
          id={input.id}
          label={input.label}
          type={'textEditor'}
          forceinitialvalue={input.initialValue || input.forceinitialvalue}
          additionalonchangefunction={input.additionalonchangefunction}
        />
      )}
    />
  ) : input.type === 'duration' ? (
    <Controller
      control={control}
      shouldUnregister
      name={input.name}
      defaultValue={input.initialValue}
      rules={
        input.required && typeof input.customValidation === 'function'
          ? { required: input.required, validate: input.customValidation }
          : { required: input.required }
      }
      render={({ field, fieldState }) => (
        <DurationInput
          field={field}
          fieldstate={fieldState}
          required={input.required === true}
          id={input.id}
          label={input.label}
          useDays={input.useDays}
          useHours={input.useHours}
          useMinutes={input.useMinutes}
          useSeconds={input.useSeconds}
          forceinitialvalue={input.initialValue || input.forceinitialvalue}
          min={input.min}
          max={input.max}
          allowDecimals={input.allowDecimals}
          decimalsPrecision={input.decimalsPrecision}
          additionalonchangefunction={input.additionalonchangefunction}
        />
      )}
    />
  ) : input.type === 'number' ? (
    <Controller
      control={control}
      shouldUnregister
      name={input.name}
      defaultValue={input.initialValue}
      rules={
        input.required && typeof input.customValidation === 'function'
          ? { required: input.required, validate: input.customValidation }
          : { required: input.required }
      }
      render={({ field, fieldState }) => (
        <NumericalInput
          field={field}
          fieldstate={fieldState}
          required={input.required === true}
          id={input.id}
          label={input.label}
          metric={input.metric}
          forceinitialvalue={input.forceinitialvalue || input.initialValue}
          allowUndefined={input.allowUndefined}
          allowZero={input.allowZero}
          appendcomponent={input.appendcomponent}
          useNumberSpinner={input.useNumberSpinner}
          allowDecimals={input.allowDecimals}
          decimalsPrecision={input.decimalsPrecision}
          step={input.step ?? 1}
          min={input.min}
          max={input.max}
          placeholder={input.placeholder}
          additionalonchangefunction={input.additionalonchangefunction}
          maxLength={input.maxLength}
        />
      )}
    />
  ) : input.type === 'time' ? (
    <Controller
      control={control}
      shouldUnregister
      name={input.name}
      defaultValue={input.initialValue}
      rules={
        input.required && typeof input.customValidation === 'function'
          ? { required: input.required, validate: input.customValidation }
          : { required: input.required }
      }
      render={({ field, fieldState }) => (
        <TimeInput
          field={field}
          fieldstate={fieldState}
          required={input.required === true}
          label={input.label}
          allowNulls={input.allowNulls}
          minTime={input.minTime}
          maxTime={input.maxTime}
        />
      )}
    />
  ) : input.type === 'colorPicker' ? (
    <Controller
      control={control}
      shouldUnregister
      name={input.name}
      defaultValue={input.initialValue}
      rules={
        input.required && typeof input.customValidation === 'function'
          ? { required: input.required, validate: input.customValidation }
          : { required: input.required }
      }
      render={({ field }) => (
        <ColorPicker
          field={field}
          required={input.required === true}
          id={input.id}
          label={input.label}
          disabled={input.disabled}
          forceinitialvalue={input.forceinitialvalue || input.initialValue}
          additionalonchangefunction={input.additionalonchangefunction}
        />
      )}
    />
  ) : input.type === 'jobTypeDropdown' ? (
    <Controller
      control={control}
      shouldUnregister
      name={input.name}
      defaultValue={input.initialValue}
      rules={
        input.required && typeof input.customValidation === 'function'
          ? { required: input.required, validate: input.customValidation }
          : { required: input.required }
      }
      render={({ field, fieldState }) => (
        <JobTypeDropdownInput
          field={field}
          fieldstate={fieldState}
          id={input.id}
          required={input.required}
          forceinitialvalue={input.forceinitialvalue || input.initialValue}
          additionalonchangefunction={input.additionalonchangefunction}
        />
      )}
    />
  ) : input.type === 'jobPriorityDropdown' ? (
    <Controller
      control={control}
      shouldUnregister
      name={input.name}
      defaultValue={input.initialValue}
      rules={
        input.required && typeof input.customValidation === 'function'
          ? { required: input.required, validate: input.customValidation }
          : { required: input.required }
      }
      render={({ field, fieldState }) => (
        <JobPriorityDropdownInput
          field={field}
          fieldstate={fieldState}
          id={input.id}
          required={input.required}
          forceinitialvalue={input.forceinitialvalue || input.initialValue}
          additionalonchangefunction={input.additionalonchangefunction}
        />
      )}
    />
  ) : input.type === 'jobStatusDropdown' ? (
    <Controller
      control={control}
      shouldUnregister
      name={input.name}
      defaultValue={input.initialValue}
      rules={
        input.required && typeof input.customValidation === 'function'
          ? { required: input.required, validate: input.customValidation }
          : { required: input.required }
      }
      render={({ field, fieldState }) => (
        <JobStatusDropdownInput
          field={field}
          fieldstate={fieldState}
          id={input.id}
          required={input.required}
          forceinitialvalue={input.forceinitialvalue || input.initialValue}
          additionalonchangefunction={input.additionalonchangefunction}
        />
      )}
    />
  ) : input.type === 'locationClassesDropdown' ? (
    <Controller
      control={control}
      shouldUnregister
      name={input.name}
      defaultValue={input.initialValue}
      rules={
        input.required && typeof input.customValidation === 'function'
          ? { required: input.required, validate: input.customValidation }
          : { required: input.required }
      }
      render={({ field, fieldState }) => (
        <LocationClassesDropdownInput
          field={field}
          fieldstate={fieldState}
          id={input.id}
          required={input.required}
          forceinitialvalue={input.forceinitialvalue || input.initialValue}
          additionalonchangefunction={input.additionalonchangefunction}
        />
      )}
    />
  ) : input.type === 'geofenceShapesDropdown' ? (
    <Controller
      control={control}
      shouldUnregister
      name={input.name}
      defaultValue={input.initialValue}
      rules={
        input.required && typeof input.customValidation === 'function'
          ? { required: input.required, validate: input.customValidation }
          : { required: input.required }
      }
      render={({ field, fieldState }) => (
        <GeofenceShapeDropdownInput
          field={field}
          fieldstate={fieldState}
          id={input.id}
          required={input.required}
          disabled={input.disabled}
          forceinitialvalue={input.forceinitialvalue || input.initialValue}
          additionalonchangefunction={input.additionalonchangefunction}
        />
      )}
    />
  ) : input.type === 'locationDropdown' ? (
    <Controller
      control={control}
      shouldUnregister
      name={input.name}
      defaultValue={input.initialValue}
      rules={
        input.required && typeof input.customValidation === 'function'
          ? { required: input.required, validate: input.customValidation }
          : { required: input.required }
      }
      render={({ field, fieldState }) => (
        <LocationsDropdownInput
          field={field}
          fieldstate={fieldState}
          id={input.id}
          required={input.required}
          locationsFilters={input.locationsFilters}
        />
      )}
    />
  ) : input.type === 'driverDropdown' ? (
    <Controller
      control={control}
      shouldUnregister
      name={input.name}
      defaultValue={input.initialValue}
      rules={
        input.required && typeof input.customValidation === 'function'
          ? { required: input.required, validate: input.customValidation }
          : { required: input.required }
      }
      render={({ field, fieldState }) => (
        <DriversDropdownInput
          field={field}
          fieldstate={fieldState}
          id={input.id}
          required={input.required}
          isClearable={input.isClearable}
          driversFilters={input.driversFilters}
        />
      )}
    />
  ) : input.type === 'geofenceDropdown' ? (
    <Controller
      control={control}
      shouldUnregister
      name={input.name}
      defaultValue={input.initialValue}
      rules={
        input.required && typeof input.customValidation === 'function'
          ? { required: input.required, validate: input.customValidation }
          : { required: input.required }
      }
      render={({ field, fieldState }) => (
        <GeofencesDropdownInput
          field={field}
          fieldstate={fieldState}
          id={input.id}
          label={input.label}
          placeholder={input.placeholder}
          isClearable={input.isClearable}
          required={input.required}
          parentGeofences={input.parentGeofences}
          subGeofenceWktString={input.subGeofenceWktString}
          additionalonchangefunction={input.additionalonchangefunction}
          subGeofences={input.subGeofences}
        />
      )}
    />
  ) : input.type === 'organizationFormsDropdown' ? (
    <Controller
      control={control}
      shouldUnregister
      name={input.name}
      defaultValue={input.initialValue}
      rules={
        input.required && typeof input.customValidation === 'function'
          ? { required: input.required, validate: input.customValidation }
          : { required: input.required }
      }
      render={({ field, fieldState }) => (
        <FormsDropdown
          field={field}
          fieldstate={fieldState}
          isInModal={true}
          isClearable={input.isClearable}
          isMultiple={input.isMultiple}
          id={input.id}
          forceinitialvalue={input.forceinitialvalue || input.initialValue}
          label={input.label}
        />
      )}
    />
  ) : input.type === 'usersDropdown' ? (
    <Controller
      control={control}
      shouldUnregister
      name={input.name}
      defaultValue={input.initialValue}
      rules={
        input.required && typeof input.customValidation === 'function'
          ? { required: input.required, validate: input.customValidation }
          : { required: input.required }
      }
      render={({ field, fieldState }) => (
        <UsersDropdown
          field={field}
          fieldstate={fieldState}
          isInModal={true}
          isClearable={input.isClearable}
          isMultiple={input.isMultiple}
          id={input.id}
          usersFilters={input.usersFilters}
          forceinitialvalue={input.forceinitialvalue || input.initialValue}
          label={input.label}
        />
      )}
    />
  ) : input.type === 'contactsDropdown' ? (
    <ContactsDropdown
      control={control}
      shouldUnregister
      name={input.name}
      id={input.id}
      initialFetch={input.initialFetch}
      defaultContacts={input.defaultContacts || input.initialValue}
      isInModal={true}
      label={input.label}
    />
  ) : input.type === 'customersDropdown' ? (
    <Controller
      control={control}
      shouldUnregister
      name={input.name}
      defaultValue={input.initialValue}
      rules={{ required: input.required }}
      render={({ field, fieldState }) => (
        <CustomersDropdown
          field={field}
          fieldstate={fieldState}
          isInModal={true}
          id={input.id}
          isClearable={input.isClearable}
          customersFilters={input.customersFilters}
          label={input.label}
          required={input.required}
        />
      )}
    />
  ) : input.type === 'unitsDropdown' ? (
    <Controller
      control={control}
      shouldUnregister
      name={input.name}
      defaultValue={input.initialValue}
      rules={
        input.required && typeof input.customValidation === 'function'
          ? { required: input.required, validate: input.customValidation }
          : { required: input.required }
      }
      render={({ field, fieldState }) => (
        <UnitsDropdown
          field={field}
          fieldstate={fieldState}
          isInModal={true}
          isClearable={input.isClearable}
          options={input.options}
          isMultiple={input.isMultiple}
          id={input.id}
          unitsFilters={input.unitsFilters}
          forceinitialvalue={input.forceinitialvalue}
          label={input.label}
        />
      )}
    />
  ) : input.type === 'scheduleDropdown' ? (
    <Controller
      control={control}
      shouldUnregister
      name={input.name}
      defaultValue={input.initialValue}
      rules={
        input.required && typeof input.customValidation === 'function'
          ? { required: input.required, validate: input.customValidation }
          : { required: input.required }
      }
      render={({ field, fieldState }) => (
        <ScheduleDropdown
          field={field}
          fieldstate={fieldState}
          isInModal={true}
          isClearable={input.isClearable}
          options={input.options}
          isMultiple={input.isMultiple}
          showScheduleInformation={input.showScheduleInformation}
          id={input.id}
          forceinitialvalue={input.forceinitialvalue}
          scheduleType={input.scheduleType ?? 'trigger'}
          label={input.label}
        />
      )}
    />
  ) : input.type === 'noticeTypeDropdown' ? (
    <NoticeTypeDropdownInput id={input.id} defaultValue={input.initialValue} />
  ) : input.type === 'categoriesDropdown' ? (
    <CategoriesDropdownInput id={input.id} name={input.name} />
  ) : input.type === 'dropDownCategoriesIcons' ? (
    <DropdownCategoriesIcons name={input.name} id={input.id} defaultValue={input.initialValue} />
  ) : input.type === 'switch' ? (
    <Controller
      control={control}
      shouldUnregister
      name={input.name}
      defaultValue={input.initialValue}
      rules={
        input.required && typeof input.customValidation === 'function'
          ? { required: input.required, validate: input.customValidation }
          : { required: input.required }
      }
      render={({ field }) => (
        <SwitchInput
          field={field}
          label={input.label}
          forceinitialvalue={input.forceinitialvalue}
          additionalonchangefunction={input.additionalonchangefunction}
        />
      )}
    />
  ) : input.type === 'radioButtons' ? (
    <Controller
      control={control}
      shouldUnregister
      name={input.name}
      defaultValue={input.initialValue}
      rules={
        input.required && typeof input.customValidation === 'function'
          ? { required: input.required, validate: input.customValidation }
          : { required: input.required }
      }
      render={({ field, fieldState }) => (
        <RadioButtonsInput
          field={field}
          fieldstate={fieldState}
          isInModal={true}
          label={input.label}
          radioButtons={input.radioButtons}
          additionalonchangefunction={input.additionalonchangefunction}
        />
      )}
    />
  ) : input.type === 'checkbox' ? (
    <Controller
      control={control}
      shouldUnregister
      name={input.name}
      defaultValue={input.initialValue}
      rules={
        input.required && typeof input.customValidation === 'function'
          ? { required: input.required, validate: input.customValidation }
          : { required: input.required }
      }
      render={({ field, fieldState }) => (
        <CheckboxInput
          field={field}
          label={input.label}
          forceinitialvalue={input.forceinitialvalue}
        />
      )}
    />
  ) : input.type === 'checkbox' ? (
    <Controller
      control={control}
      shouldUnregister
      name={input.name}
      defaultValue={input.initialValue}
      rules={
        input.required && typeof input.customValidation === 'function'
          ? { required: input.required, validate: input.customValidation }
          : { required: input.required }
      }
      render={({ field, fieldState }) => (
        <CheckboxInput
          field={field}
          label={input.label}
          forceinitialvalue={input.forceinitialvalue}
        />
      )}
    />
  ) : input.type === 'membership' ? (
    <Membership
      control={control}
      shouldUnregister
      key={input.id}
      name={input.name}
      defaultValue={input.initialValue}
      isInModal={true}
      options={input.options}
      additionalonchangefunction={input.additionalonchangefunction}
    />
  ) : input.type === 'unitThemeDropdown' ? (
    <Controller
      control={control}
      name={input.name}
      rules={{ required: input.required }}
      defaultValue={input.initialValue}
      render={({ field, fieldState }) => (
        <ThemeDropdown
          field={field}
          fieldstate={fieldState}
          id={input.id}
          label={input.label ? input.label : <FormattedMessage id="units.theme" />}
          placeholder={
            input.placeholder ? (
              input.placeholder
            ) : (
              <FormattedMessage id="trackingUnits.selectTheme" />
            )
          }
          forceinitialvalue={input.initialValue}
          required
        />
      )}
    />
  ) : input.type === 'custom' ? (
    <Controller
      control={control}
      shouldUnregister
      name={input.name}
      defaultValue={input.initialValue}
      rules={
        input.required && typeof input.customValidation === 'function'
          ? { required: input.required, validate: input.customValidation }
          : { required: input.required }
      }
      render={({ field, fieldState }) => (
        <input.component
          id={input.id}
          // isInModal={true}
          options={input.options}
          onBlur={(event, newValue, previousValue, name) => {
            change('validationHack', Date.now());
          }}
          label={input.label ? appIntl().formatMessage({ id: input.label }) : null}
          {...input}
        />
      )}
    />
  ) : input.type === 'component' ? (
    <div id={input.id}>{input.component}</div>
  ) : null;
};

WebtrackCustomInput.defaultProps = {
  input: {}
};

export default WebtrackCustomInput;
